const data = {
  piuTariffeOptions: [
    { code: "1.1b", description: "Sì" },
    { code: "1.2b", description: "No" },
  ],
  // Elenco Compagnie: tbd (2b)
  compagniaOptions: [
    { code: "2.1" , description: "AIG Europe" },
    { code: "2.2" , description: "Alleanza Assicurazioni" },
    { code: "2.3" , description: "Allianz" },
    { code: "2.4" , description: "Allianz Global Assistance" },
    { code: "2.5" , description: "Allianz Global Corporate & Specialty" },
    { code: "2.15" , description: "Allianz Viva" },
    { code: "2.7" , description: "AmTrust Assicurazioni" },
    { code: "2.8" , description: "ARAG" },
    { code: "2.9" , description: "Arca Assicurazioni" },
    { code: "2.10" , description: "ArgoGlobal Assicurazioni" },
    { code: "2.11" , description: "Assicuratrice Milanese" },
    { code: "2.12" , description: "Assicuratrice Val Piave" },
    { code: "2.13" , description: "Assicurazioni Rischi Agricoli 1857" },
    { code: "2.14" , description: "Assimoco" },
    { code: "2.16" , description: "AXA Assicurazioni" },
    { code: "2.17" , description: "AXA-MPS Assicurazioni Danni" },
    { code: "2.18" , description: "BCC Assicurazioni" },
    { code: "2.19" , description: "Banco BPM Assicurazioni" },
    { code: "2.20" , description: "Banco BPM Vita" },
    { code: "2.21" , description: "Cardif Risques Divers" },
    { code: "2.22" , description: "CARGEAS Assicurazioni" },
    { code: "2.23" , description: "Cattolica Assicurazioni" },
    { code: "2.24" , description: "CF Assicurazioni" },
    { code: "2.25" , description: "CGPA Europe" },
    { code: "2.26" , description: "Chiara Assicurazioni" },
    { code: "2.27" , description: "Chubb European Group" },
    { code: "2.28" , description: "CNA Insurance Company" },
    { code: "2.29" , description: "Credemassicurazioni" },
    { code: "2.30" , description: "Crédit Agricole Assicurazioni" },
    { code: "2.32" , description: "DARAG" },
    { code: "2.33" , description: "DAS" },
    { code: "2.34" , description: "Elba Assicurazioni" },
    { code: "2.35" , description: "Europ Assistance" },
    { code: "2.36" , description: "FM Insurance Europe" },
    { code: "2.37" , description: "Generali Italia" },
    { code: "2.38" , description: "Genertel" },
    { code: "2.39" , description: "Genialloyd" },
    { code: "2.40" , description: "Global Assistance" },
    { code: "2.41" , description: "Groupama Assicurazioni" },
    { code: "2.42" , description: "HDI Assicurazioni" },
    { code: "2.43" , description: "HDI Global Specialty" },
    { code: "2.6" , description: "HDI Italia" },
    { code: "2.44" , description: "Helvetia Assicurazioni" },
    { code: "2.45" , description: "Helvetia Italia Assicurazioni" },
    { code: "2.46" , description: "IMA Italia Assistance" },
    { code: "2.47" , description: "Incontra Assicurazioni" },
    { code: "2.48" , description: "Inter Partner Assistance" },
    { code: "2.49" , description: "Intesa Sanpaolo Assicura" },
    { code: "2.87" , description: "Intesa Sanpaolo Protezione" },
    { code: "2.50" , description: "Intesa Sanpaolo RBM Salute" },
    { code: "2.51" , description: "Italiana Assicurazioni" },
    { code: "2.52" , description: "ITAS Mutua" },
    { code: "2.53" , description: "Le Assicurazioni di Roma" },
    { code: "2.54" , description: "Liberty Mutual Insurance" },
    { code: "2.55" , description: "Linear" },
    { code: "2.56" , description: "Lloyd's" },
    { code: "2.57" , description: "MAPFRE ASISTENCIA" },
    { code: "2.58" , description: "Mediolanum Assicurazioni" },
    { code: "2.59" , description: "MetLife" },
    { code: "2.60" , description: "Net Insurance" },
    { code: "2.61" , description: "Nobis Assicurazioni" },
    { code: "2.62" , description: "Poste Assicura" },
    { code: "2.63" , description: "Pramerica Life" },
    { code: "2.64" , description: "Prima Assicurazioni" },
    { code: "2.65" , description: "QBE Insurance" },
    { code: "2.66" , description: "QUIXA Assicurazioni" },
    { code: "2.67" , description: "Reale Mutua" },
    { code: "2.68" , description: "Sara Assicurazioni" },
    { code: "2.69" , description: "SIAT" },
    { code: "2.70" , description: "Società Svizzera d'Assicurazione contro la Grandine" },
    { code: "2.71" , description: "SOGESSUR" },
    { code: "2.72" , description: "Swiss Re International" },
    { code: "2.73" , description: "Tiroler Versicherung" },
    { code: "2.74" , description: "Tokio Marine Europe" },
    { code: "2.75" , description: "TUA Assicurazioni" },
    { code: "2.76" , description: "Tutela Legale" },
    { code: "2.77" , description: "UCA Assicurazioni" },
    { code: "2.31" , description: "UniCredit Allianz Assicurazioni" },
    { code: "2.78" , description: "UnipolSai Assicurazioni" },
    { code: "2.79" , description: "UniSalute" },
    { code: "2.80" , description: "PiùVera Assicurazioni" },
    { code: "2.81" , description: "Verti Assicurazioni" },
    { code: "2.82" , description: "VH Italia Assicurazioni" },
    { code: "2.83" , description: "Vittoria Assicurazioni" },
    { code: "2.84" , description: "XL Insurance Company" },
    { code: "2.85" , description: "Zurich Connect" },
    { code: "2.86" , description: "Zurich Insurance" },
  ],
  canaleOptions: [
    { code: "3.1", description: "Banca" },
    { code: "3.2", description: "Consulenti Finanziari" },
    { code: "3.3", description: "Agenti" },
    { code: "3.4", description: "Broker" },
    { code: "3.5", description: "Diretto" },
    { code: "3.6", description: "Ente Finanziario" },
  ],
  modDistribuzioneOptions: [
    { code: "5.1", description: "Fisica" },
    { code: "5.2", description: "Online" },
    { code: "5.3", description: "Telemarketing" },
  ],
  mercatoOptions: [
    { code: "6.1", description: "Retail" },
    { code: "6.2", description: "Business" },
  ],
  lineaBusinessOptions: [
    { code: "10.1", description: "Mobilità" },
    { code: "10.2", description: "Persona" },
    { code: "10.3", description: "Casa e Famiglia" },
    { code: "10.4", description: "Azienda" },
    { code: "10.5", description: "Professionisti" },
  ],
  tipologiaGaranzieMobilitaOptions: [
    { code: "11.1", description: "Sharing/Noleggio" },
    { code: "11.2", description: "Bike" },
    { code: "11.3", description: "Vita privata in mobilità" },
    { code: "11.4", description: "Viaggi" },
  ],
  tipologiaGaranziePersonaOptions: [
    { code: "12.1", description: "Infortuni" },
    { code: "12.2", description: "Salute" },
    { code: "12.3", description: "Dentaria" },
    { code: "12.4", description: "Servizi di assistenza alla persona" },
  ],
  tipologiaGaranzieCasaEFamigliaOptions: [
    { code: "13.1", description: "Casa" },
    { code: "13.2", description: "Famiglia" },
  ],
  tipologiaGaranzieAziendaOptions: [
    { code: "14.1", description: "Azienda (generico)" },
    { code: "14.2", description: "Azienda agricola/ricettiva" },
    { code: "14.3", description: "Azienda agroalimentare" },
    { code: "14.4", description: "Azienda manifatturiera" },
    { code: "14.5", description: "Azienda settore commercio" },
    { code: "14.6", description: "Imprese artigiane" },
    { code: "14.7", description: "Altre attività" },
  ],
  tipologiaGaranzieProfessionistiOptions: [
    { code: "15.1", description: "RC Professionale" },
    { code: "15.2", description: "Copertura beni" },
  ],
  prodCommercioOptions: [
    { code: "16.1", description: "Sì" },
    { code: "16.2", description: "No" },
  ],
  tipoAssicurazioneOptions: [
    { code: "20.1", description: "Individuale" },
    { code: "20.2", description: "Collettiva" },
  ],
  combGaranzieTipologiaOptions: [
    { code: "22.1", description: "A formule" },
    { code: "22.2", description: "Modulare" },
    { code: "22.3", description: "Modulare / A formule" },
    { code: "22.4", description: "Pacchetto chiuso" },
    { code: "22.5", description: "Pacchetto chiuso / A formule" },
  ],
  premioTipologiaOptions: [
    { code: "24.1", description: "Annuo" },
    { code: "24.2", description: "Mensile" },
    { code: "24.3", description: "Unico" },
  ],
  frazPremioOptions: [
    { code: "26.1", description: "Mensile" },
    { code: "26.2", description: "Bimestrale" },
    { code: "26.3", description: "Trimestrale" },
    { code: "26.4", description: "Quadrimestrale" },
    { code: "26.5", description: "Semestrale" },
    { code: "26.6", description: "Non previsto" },
  ],
  rischiAssicuratiMobilitaOptions: [
    { code: "29.1", description: "Infortuni su mezzi sharing" },
    { code: "29.2", description: "Infortuni in bicicletta" },
    { code: "29.3a", description: "Responsabilità civile in bicicletta" },
    { code: "29.3b", description: "Responsabilità civile per danni da utilizzo di monopattino elettrico" },
    { code: "29.4", description: "Tutela legale in bicicletta" },
    { code: "29.5", description: "Furto bicicletta" },
    { code: "29.6", description: "Assistenza bicicletta" },
    { code: "29.7", description: "Danni causati a terzi in mobilità" },
    { code: "29.8", description: "Infortuni su mezzi pubblici" },
    { code: "29.9", description: "Infortuni in viaggio" },
    { code: "29.10", description: "Rimborso spese mediche in viaggio" },
    { code: "29.11", description: "Furto in viaggio" },
    { code: "29.12", description: "Furto bagaglio" },
    { code: "29.13", description: "Annullamento viaggio" },
    { code: "29.14", description: "Assistenza in viaggio" },
    { code: "29.15", description: "Altre garanzie Mobilità" },
  ],
  assistenzaBiciclettaMobilitaTipologiaOptions: [
    { code: "33.1", description: "Invio mezzo di soccorso per trasportare la bicicletta e l’assicurato al domicilio" },
    { code: "33.2", description: "Bicicletta sostitutiva in caso di guasto/incidente" },
    { code: "33.3", description: "Consulenza medica h24 a seguito di infortunio in bicicletta" },
    { code: "33.4", description: "Invio di un medico o di un'ambulanza a seguito di infortunio in bicicletta" },
    { code: "33.5", description: "Invio di un fisioterapista a seguito di infortunio in bicicletta" },
    { code: "33.6", description: "Invio di una collaboratrice domestica a seguito di infortunio in bicicletta" },
    { code: "33.7", description: "Rientro dell'assicurato a seguito di infortunio e/o incidente" },
    { code: "33.8", description: "Rientro sanitario a seguito di infortunio in bicicletta" },
    { code: "33.9", description: "Viaggio di un familiare in caso di ricovero a seguito di infortunio in bicicletta" },
    { code: "33.10", description: "Spese di albergo" },
    { code: "33.11", description: "Trasporto della bicicletta in caso di guasto/incidente" },
    { code: "33.12", description: "Altro:" },
  ],
  assistenzaInViaggioMobilitaTipologiaOptions: [
    { code: "41.1", description: "Consulenza medica h24" },
    { code: "41.2", description: "Invio di un medico o di un'ambulanza in Italia" },
    { code: "41.3", description: "Segnalazione di un medico specialista all’estero" },
    { code: "41.4", description: "Traduzione cartella clinica" },
    { code: "41.5", description: "Invio medicinali all'estero" },
    { code: "41.6", description: "Rientro sanitario" },
    { code: "41.7", description: "Rientro salma" },
    { code: "41.8", description: "Trasferimento in centro ospedaliero" },
    { code: "41.9", description: "Viaggio di un familiare" },
    { code: "41.10", description: "Accompagnamento dei minori" },
    { code: "41.11", description: "Prolungamento del soggiorno per motivi di salute" },
    { code: "41.12", description: "Interprete a disposizione all'estero" },
    { code: "41.13", description: "Anticipo spese di prima necessità" },
    { code: "41.14", description: "Rientro anticipato" },
    { code: "41.15", description: "Reperimento di un legale" },
    { code: "41.16", description: "Anticipo cauzione civile" },
    { code: "41.17", description: "Anticipo cauzione penale" },
    { code: "41.18", description: "Altro:" },
  ],
  rischiAssicuratiPersonaOptions: [
    { code: "44.1", description: "Morte da infortunio" },
    { code: "44.2", description: "Invalidità permanente da infortunio" },
    { code: "44.3", description: "Inabilità temporanea da infortunio" },
    { code: "44.4", description: "Infortunio con indennizzo forfettario" },
    { code: "44.5", description: "Morte da malattia" },
    { code: "44.6", description: "Invalidità permanente da malattia" },
    { code: "44.7", description: "Inabilità temporanea da malattia" },
    { code: "44.8a", description: "Gravi patologie (Malattie gravi)" },
    { code: "44.8b", description: "Cure oncologiche" },
    { code: "44.9", description: "Diaria da ricovero da infortunio/malattia" },
    { code: "44.10a", description: "Diaria da convalescenza" },
    { code: "44.10b", description: "Diaria da immobilizzazione" },
    { code: "44.11", description: "Rimborso spese mediche generiche" },
    { code: "44.12", description: "Rimborso spese mediche per grande intervento chirurgico" },
    { code: "44.13", description: "Rimborso spese mediche per ricovero o intervento chirurgico in genere" },
    { code: "44.14a", description: "Visite specialistiche e accertamenti diagnostici" },
    { code: "44.14b", description: "Prestazioni di alta specializzazione" },
    { code: "44.14c", description: "Trattamenti fisioterapici rieducativi" },
    { code: "44.15", description: "Intervento chirurgico con indennizzo forfettario" },
    { code: "44.16", description: "Gravi ricoveri con indennizzo forfettario" },
    { code: "44.17a", description: "Stato di non autosufficienza" },
    { code: "44.17b", description: "Stato di non autosufficienza temporanea" },
    { code: "44.18", description: "Cure dentarie" },
    { code: "44.19", description: "Assistenza alla persona" },
    { code: "44.20", description: "Esami di prevenzione (Check-up)" },
    { code: "44.21", description: "Danni estetici" },
    { code: "44.22", description: "Lenti correttive da vista" },
    { code: "44.23", description: "Tutela legale persona" },
    { code: "44.24", description: "Altre garanzie Persona" },
  ],
  assistenzaAllaPersonaTipologiaOptions: [
    { code: "63.1" , description: "Informazioni sanitarie" },
    { code: "63.2" , description: "Invio di una baby sitter" },
    { code: "63.3" , description: "Invio di una collaboratrice familiare" },
    { code: "63.4" , description: "Invio di un medico generico" },
    { code: "63.5" , description: "Invio di un medico specialista" },
    { code: "63.6" , description: "Trasferimento da/verso un centro ospedaliero" },
    { code: "63.7" , description: "Trasporto in ambulanza" },
    { code: "63.8" , description: "Invio di un infermiere o fisioterapista a domicilio" },
    { code: "63.9" , description: "Viaggio di un familiare" },
    { code: "63.10" , description: "Rientro anticipato" },
    { code: "63.11" , description: "Spese di albergo/vitto e pernottamento dell'accompagnatore nell'Istituto di cura" },
    { code: "63.12" , description: "Consulenza medica h24" },
    { code: "63.13" , description: "Consulenza pediatrica" },
    { code: "63.14" , description: "Consulenza psicologica" },
    { code: "63.15" , description: "Consulenza alimentare" },
    { code: "63.16" , description: "Interprete a disposizione all’estero" },
    { code: "63.17" , description: "Anticipo spese di prima necessità" },
    { code: "63.18" , description: "Prolungamento del soggiorno" },
    { code: "63.19" , description: "Rientro salma" },
    { code: "63.20" , description: "Second opinion" },
    { code: "63.21" , description: "Diagnostica domiciliare post ricovero" },
    { code: "63.22" , description: "Servizi sanitari post ricovero" },
    { code: "63.23" , description: "Assistenza infermieristica privata durante il ricovero" },
    { code: "63.24" , description: "Assistenza professionale domiciliare per familiare non autosufficiente" },
    { code: "63.25" , description: "Assistenza domiciliare integrata" },
    { code: "63.26" , description: "Invio di medicinali all’estero" },
    { code: "63.27" , description: "Accompagnamento di minori" },
    { code: "63.28" , description: "Altro:" },
  ],
  tutelaLegalePersonaTipologiaOptions: [
    { code: "68.1" , description: "Azione in sede civile per infortuni subiti per fatto illecito di terzi" },
    { code: "68.2" , description: "Vertenze contro strutture sanitarie (medical malpractice)" },
    { code: "68.3" , description: "Controversie contro il personale medico" },
    { code: "68.4" , description: "Difesa giudiziale o extragiudiziale per fatti inerenti il ricovero" },
    { code: "68.5" , description: "Controversie con istituti o enti pubblici di assicurazioni previdenziali o sociali" },
    { code: "68.6" , description: "Altro:" },
  ],
  rischiAssicuratiCasaEFamigliaOptions: [
    { code: "73.1" , description: "Incendio - Mutui" },
    { code: "73.2" , description: "Incendio - Fabbricato" },
    { code: "73.3" , description: "Incendio - Contenuto" },
    { code: "73.4" , description: "Incendio - Altri rischi" },
    { code: "73.5" , description: "Ricorso terzi" },
    { code: "73.6" , description: "Rischi catastrofali - Terremoto" },
    { code: "73.7" , description: "Rischi catastrofali - Alluvione/Inondazione" },
    { code: "73.8" , description: "RC - Proprietà del fabbricato" },
    { code: "73.9" , description: "RC - Conduzione" },
    { code: "73.10" , description: "RC - Vita privata" },
    { code: "73.11" , description: "RC - RCO" },
    { code: "73.12" , description: "RC - AltrI rischi" },
    { code: "73.13" , description: "Cristalli" },
    { code: "73.14" , description: "Furto e rapina" },
    { code: "73.15" , description: "Assistenza casa e famiglia" },
    { code: "73.16" , description: "Tutela legale casa e famiglia" },
    { code: "73.17" , description: "Elettronica" },
    { code: "73.18" , description: "Cyber risk/Rischi tecnologici casa e famiglia" },
    { code: "73.19" , description: "Animali domestici" },
    { code: "73.20" , description: "Altre garanzie Casa e Famiglia" },
  ],
  incendioAltriRischiCasaEFamigliaTipologiaOptions: [
    { code: "77.1" , description: "Acqua condotta/Spargimento di acqua" },
    { code: "77.2" , description: "Ricerca/Riparazione guasti da acqua" },
    { code: "77.3" , description: "Fenomeno elettrico" },
    { code: "77.4" , description: "Fenomeni atmosferici" },
    { code: "77.5" , description: "Sovraccarico neve" },
    { code: "77.6" , description: "Grandine" },
    { code: "77.7" , description: "Eventi sociopolitici/Atti vandalici" },
    { code: "77.8" , description: "Spese di trasloco" },
    { code: "77.9" , description: "Rifacimento documenti" },
    { code: "77.10" , description: "Altro:" },
  ],
  assistenzaCasaEFamigliaTipologiaOptions: [
    { code: "89.1" , description: "Invio di un idraulico in caso di emergenza" },
    { code: "89.2" , description: "Invio di un elettricista in caso di emergenza" },
    { code: "89.3" , description: "Invio di un fabbro in caso di emergenza" },
    { code: "89.4" , description: "Invio di un artigiano in caso di emergenza" },
    { code: "89.5" , description: "Invio di un termoidraulico in caso di emergenza" },
    { code: "89.6" , description: "Invio di un fabbro/serramentista in caso di emergenza" },
    { code: "89.7" , description: "Invio di un tapparellista in caso di emergenza" },
    { code: "89.8" , description: "Invio di un vetraio in caso di emergenza" },
    { code: "89.9" , description: "Invio di un tecnico condizionatori in caso di emergenza" },
    { code: "89.10" , description: "Invio di un tecnico riparatore di elettrodomestici in caso di emergenza" },
    { code: "89.11" , description: "Interventi di emergenza per danni da acqua" },
    { code: "89.12" , description: "Invio di un sorvegliante" },
    { code: "89.13" , description: "Spese d’albergo o residence" },
    { code: "89.14" , description: "Rientro anticipato" },
    { code: "89.15" , description: "Spese di trasloco" },
    { code: "89.16" , description: "Ripristino dell'abitabilità a seguito di allagamento" },
    { code: "89.17" , description: "Ripristino di impianti di riscaldamento o condizionamento entro 24 ore nei giorni feriali" },
    { code: "89.18" , description: "Consulenza veterinaria/ Informazioni sui centri di pronto soccorso veterinario" },
    { code: "89.19" , description: "Trasporto di elettrodomestici" },
    { code: "89.20" , description: "Reperimento telefonico di un'impresa per la disinfestazione o derattizzazione dell'abitazione" },
    { code: "89.21" , description: "Accesso a rete di artigiani" },
    { code: "89.22" , description: "Effetti personali in caso di emergenza" },
    { code: "89.23" , description: "Viaggio di un familiare" },
    { code: "89.24" , description: "Invio di un taxi" },
    { code: "89.25" , description: "Spese di rifacimento documenti" },
    { code: "89.26" , description: "Spese di rifacimento chiavi" },
    { code: "89.27" , description: "Anticipo spese di prima necessità all'estero" },
    { code: "89.28" , description: "Assistenza linguistica all’estero/interprete" },
    { code: "89.29" , description: "Tecnologia homebox" },
    { code: "89.30" , description: "Altro:" },
  ],
  tutelaLegaleCasaEFamigliaTipologiaOptions: [
    { code: "91.1" , description: "Difesa in sede civile per danni extracontattuali a persone e/o a cose subiti per fatti illeciti di terzi" },
    { code: "91.2" , description: "Controversie per inadempienze contrattuali" },
    { code: "91.3" , description: "Controversie derivanti da contratti di locazione degli immobili o dalla proprietà dei locali di abitazione e pertinenze" },
    { code: "91.4" , description: "Difesa in sede penale nei procedimenti per delitti colposi e/o contravvenzioni" },
    { code: "91.5" , description: "Controversie relative a diritti reali" },
    { code: "91.6" , description: "Arbitrati per la decisione di controversie" },
    { code: "91.7" , description: "Controversie di lavoro con collaboratori domestici" },
    { code: "91.8" , description: "Difesa in sede penale nei procedimenti per reati dolosi" },
    { code: "91.9a" , description: "Difesa in sede penale per reati dolosi commessi da minori facenti parte del nucleo familiare" },
    { code: "91.9b" , description: "Controversie per danni extracontrattuali subiti dall’assicurato derivanti da incidenti stradali con veicolo guidato con patente" },
    { code: "91.10" , description: "Controversie per danni extracontrattuali subiti dall’assicurato derivanti da incidenti stradali in qualità di pedone, ciclista o alla guida di veicoli non soggetti ad assicurazione obbligatoria" },
    { code: "91.11" , description: "Controversie contrattuali, connesse all’uso di Internet, posta elettronica e servizi di e-commerce" },
    { code: "91.12" , description: "Controversie relative a uso fraudolento di terzi di carte di credito dell’assicurato tramite internet, posta elettronica o servizi di e-commerce" },
    { code: "91.13" , description: "Ricorso per la separazione consensuale tra i coniugi e per l’ottenimento del divorzio" },
    { code: "91.14" , description: "Istanza di interdizione o inabilitazione o di revoca di tali provvedimenti di un parente o di un congiunto" },
    { code: "91.15" , description: "Istanza di dichiarazione di assenza o morte presunta o di esistenza di un parente o congiunto" },
    { code: "91.16" , description: "Controversie con istituti o enti pubblici di assicurazioni previdenziali o sociali" },
    { code: "91.17" , description: "Controversie individuali relative a rapporto di lavoro dipendente" },
    { code: "91.18" , description: "Difesa in sede penale per delitti colposi o contravvenzioni connessi a lavoro dipendente" },
    { code: "91.19" , description: "Altro:" },
  ],
  rischiTecnologiciCasaEFamigliaTipologiaOptions: [
    { code: "94.1" , description: "Spese di ripristino dei sistemi informatici e dei dati" },
    { code: "94.2" , description: "Tutela legale per Lesione della reputazione on-line" },
    { code: "94.3" , description: "Tutela legale per Furto d'identità digitale" },
    { code: "94.4" , description: "Tutela legale per controversie da acquisti on-line/e-commerce" },
    { code: "94.5" , description: "Protezione per la perdita di dati" },
    { code: "94.6" , description: "Assistenza malware (virus informatici)" },
    { code: "94.7" , description: "Assistenza per cyber bullismo" },
    { code: "94.8" , description: "Altro:" },
  ],
  animaliDomesticiCasaEFamigliaTipologiaOptions: [
    { code: "96.1" , description: "RC per danni a terzi causati dall'animale domestico" },
    { code: "96.2" , description: "Assistenza telefonica veterinaria per salute e benessere" },
    { code: "96.3" , description: "Assistenza veterinaria in viaggio" },
    { code: "96.4" , description: "Assistenza per la ricerca dell’animale tramite collare di geolocalizzazione" },
    { code: "96.5" , description: "Assistenza per il recupero dell'animale domestico ritrovato" },
    { code: "96.6" , description: "Invio pet-sitter in caso di malattia dell’assicurato" },
    { code: "96.7" , description: "Servizi di geolocalizzazione dell'animale domestico" },
    { code: "96.8" , description: "Servizi di monitoraggio dei parametri fisici dell'animale" },
    { code: "96.9" , description: "Rimborso trasporto veterinario in caso di emergenza" },
    { code: "96.10" , description: "Rimborso visita veterinaria in caso di emergenza" },
    { code: "96.11" , description: "Rimborso spese veterinarie da infortunio e malattia" },
    { code: "96.12" , description: "Rimborso spese per esami diagnostici dell'animale domestico" },
    { code: "96.13" , description: "Rimborso spese veterinarie in viaggio" },
    { code: "96.14" , description: "Rimborso spese per il ritrovamento dell'animale domestico" },
    { code: "96.15" , description: "Tutela legale connessa alla proprietà dell’animale assicurato" },
    { code: "96.16" , description: "Altro:" },
  ],
  rischiAssicuratiAziendaOptions: [
    { code: "99.1" , description: "Incendio - Mutui " },
    { code: "99.2" , description: "Incendio - Fabbricato  " },
    { code: "99.3" , description: "Incendio - Contenuto  " },
    { code: "99.4" , description: "Incendio - Altri rischi" },
    { code: "99.5" , description: "Ricorso terzi " },
    { code: "99.6" , description: "Rischi catastrofali - Terremoto" },
    { code: "99.7" , description: "Rischi catastrofali - Alluvione/Inondazione " },
    { code: "99.8" , description: "RC - Proprietà del Fabbricato " },
    { code: "99.9" , description: "RC - RCT" },
    { code: "99.10" , description: "RC - RCO" },
    { code: "99.11" , description: "RC - Altri Rischi" },
    { code: "99.12" , description: "Furto e rapina " },
    { code: "99.13" , description: "Assistenza azienda" },
    { code: "99.14" , description: "Tutela legale azienda" },
    { code: "99.15" , description: "Elettronica " },
    { code: "99.16" , description: "Danni indiretti" },
    { code: "99.17" , description: "Vetri e insegne" },
    { code: "99.18" , description: "Cyber risk/Rischi tecnologici azienda" },
    { code: "99.19" , description: "Altre garanzie Azienda" },
  ],
  incendioAltriRischiAziendaTipologiaOptions: [
    { code: "103.1" , description: "Acqua condotta/Spargimento di acqua" },
    { code: "103.2" , description: "Ricerca/Riparazione guasti da acqua" },
    { code: "103.3" , description: "Danni a macchinari/Attrezzature" },
    { code: "103.4" , description: "Danni a merci" },
    { code: "103.5" , description: "Danni a merci trasportate" },
    { code: "103.6" , description: "Interruzione di esercizio/di attività propria" },
    { code: "103.7" , description: "Fenomeno elettrico" },
    { code: "103.8" , description: "Fenomeni atmosferici" },
    { code: "103.9" , description: "Grandine" },
    { code: "103.10" , description: "Eventi sociopolitici/Atti vandalici" },
    { code: "103.11" , description: "Altro:" },
  ],
  RCAltriRischiAziendaTipologiaOptions: [
    { code: "111.1" , description: "Cose in consegna e custodia" },
    { code: "111.2" , description: "Protezione dei dati personali" },
    { code: "111.3" , description: "Committenza auto e altri veicoli" },
    { code: "111.4" , description: "Veicoli di proprietà dei dipendenti" },
    { code: "111.5" , description: "Inquinamento accidentale" },
    { code: "111.6" , description: "Danni da interruzione di attività" },
    { code: "111.7" , description: "Somministrazione e vendita di prodotti" },
    { code: "111.8" , description: "Installazione, manutenzione, riparazione presso terzi" },
    { code: "111.9" , description: "Postuma" },
    { code: "111.10" , description: "Malattie professionali" },
    { code: "111.11" , description: "RC da prodotto difettoso" },
    { code: "111.12" , description: "Altro:" },
  ],
  assistenzaAziendaTipologiaOptions: [
    { code: "114.1" , description: "Assistenza attività" },
    { code: "114.2" , description: "Assistenza in viaggio di lavoro" },
    { code: "114.3" , description: "Invio di un idraulico in caso di emergenza" },
    { code: "114.4" , description: "Invio di un elettricista in caso di emergenza" },
    { code: "114.5" , description: "Invio di un fabbro/serrandista in caso di emergenza" },
    { code: "114.6" , description: "Invio di un vetraio in caso di emergenza" },
    { code: "114.7" , description: "Invio di un sorvegliante" },
    { code: "114.8" , description: "Informazioni su artigiani convenzionati" },
    { code: "114.9" , description: "Organizzazione viaggio dell'assicurato per rientro presso la sede dell'attività in caso di necessità" },
    { code: "114.10" , description: "Dispositivi tecnologici per la segnalazione degli allarmi" },
    { code: "114.11" , description: "Altro:" },
  ],
  tutelaLegaleAziendaTipologiaOptions: [
    { code: "116.1" , description: "Difesa in sede civile per danni extracontattuali a persone e/o a cose subiti per fatti illeciti di terzi" },
    { code: "116.2" , description: "Difesa per danni causati a terzi per fatti illeciti degli assicurati" },
    { code: "116.3" , description: "Difesa in sede penale nei procedimenti per delitti colposi e/o contravvenzioni" },
    { code: "116.4" , description: "Difesa in sede penale per omicidio colposo e/o lesioni personali colpose" },
    { code: "116.5" , description: "Difesa per sanzioni amministrative" },
    { code: "116.6" , description: "Vertenze individuali promosse da dipendenti o agenti di commercio nei confronti dell’impresa" },
    { code: "116.7" , description: "Spese liquidate alla controparte in caso di soccombenza" },
    { code: "116.8" , description: "Vertenze da proprietà, locazione, conduzione fabbricati" },
    { code: "116.9" , description: "Vertenze relative ad inadempimenti in relazione a forniture all’impresa di beni o servizi" },
    { code: "116.10" , description: "Rischi della circolazione di veicoli aziendali" },
    { code: "116.11" , description: "Altro:" },
  ],
  rischiTecnologiciAziendaTipologiaOptions: [
    { code: "121.1" , description: "Copertura della perdita e ripristino dei dati" },
    { code: "121.2" , description: "Copertura dei danni alle appaerecchiature" },
    { code: "121.3" , description: "Copertura dei costi di ricostruzione archivi" },
    { code: "121.4" , description: "Rimborso  perdite finanziarie subite in caso di furto, smarrimento o utilizzo fraudolento di mezzi di pagamento aziendali" },
    { code: "121.5" , description: "Costi di tutela della reputazione" },
    { code: "121.6" , description: "Danni da interruzione attività a seguito di attacco informatico o errore umano" },
    { code: "121.7" , description: "RC per danni a sistemi informatici e apparecchiature di terzi" },
    { code: "121.8" , description: "RC per danni a terzi da violazione della privacy e/o violazione di dati aziendali" },
    { code: "121.9" , description: "RC per danni a terzi da attività multimediale e pubblicitaria" },
    { code: "121.10" , description: "Tutela legale per procedimenti riguardanti il furto d'identità" },
    { code: "121.11" , description: "Tutela legale per far rimuovere contenuti web offensivi per la reputazione" },
    { code: "121.12" , description: "Assistenza per il recupero dei dati informatici" },
    { code: "121.13" , description: "Altro:" },
  ],
  rischiAssicuratiProfessionistiOptions: [
    { code: "124.1" , description: "RC professionale (area tecnica)" },
    { code: "124.2" , description: "RC professionale (area tecnica) - Altri Rischi" },
    { code: "124.3" , description: "RC professionale (area economica-giuridica)" },
    { code: "124.4" , description: "RC professionale (area economica-giuridica)  - Altri Rischi" },
    { code: "124.5" , description: "RC professionale (area medica)" },
    { code: "124.6" , description: "RC professionale (area medica)  - Altri Rischi" },
    { code: "124.7" , description: "RC professionale (altra area)" },
    { code: "124.8" , description: "RC - RCT" },
    { code: "124.9" , description: "RC - RCO" },
    { code: "124.10" , description: "RC - Proprietà e conduzione" },
    { code: "124.11" , description: "Assistenza professionisti" },
    { code: "124.12" , description: "Tutela legale professionisti" },
    { code: "124.13" , description: "Cyber risk/Rischi tecnologici professionisti" },
    { code: "124.14" , description: "Infortuni" },
    { code: "124.15" , description: "Incendio e danni alla proprietà" },
    { code: "124.16" , description: "Furto e rapina" },
    { code: "124.17" , description: "Elettronica" },
    { code: "124.18" , description: "Vetri e cristalli" },
    { code: "124.19" , description: "Altre garanzie Professionisti" },
  ],
  RCProfAreaTecnicaAltriRischiTipologiaOptions: [
    { code: "126.1" , description: "Perdita documenti e valori" },
    { code: "126.2" , description: "Inquinamento accidentale" },
    { code: "126.3" , description: "Consulenza ambientale" },
    { code: "126.4" , description: "Certificazioni e/o dichiarazioni di conformità" },
    { code: "126.5" , description: "Errata interpretazione dei vincoli urbanistici" },
    { code: "126.6" , description: "Penalità fiscali" },
    { code: "126.7" , description: "Postuma" },
    { code: "126.8" , description: "Interruzione attività di terzi" },
    { code: "126.9" , description: "Altro:" },
  ],
  RCProfAreaEconomicaGiuridicaAltriRischiTipologiaOptions: [
    { code: "129.1" , description: "Perdita documenti e valori" },
    { code: "129.2" , description: "Fusioni e acquisizioni" },
    { code: "129.3" , description: "Penalità fiscali" },
    { code: "129.4" , description: "Interruzione attività di terzi" },
    { code: "129.5" , description: "Postuma" },
    { code: "129.6" , description: "Altro:" },
  ],
  RCProfAreaMedicaAltriRischiTipologiaOptions: [
    { code: "132.1" , description: "Prestazioni professionali rese all’esterno dello studio" },
    { code: "132.2" , description: "Acquisizione consenso informato" },
    { code: "132.3" , description: "Utilizzo di apparecchiature e strumenti medicali" },
    { code: "132.4" , description: "Danni da contagio (HIV, AIDS, Epatite C e Delta)" },
    { code: "132.5" , description: "Altro:" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
};

const selectChoices = {
  piuTariffe: { code: "", description: "" },
  compagnia: { code: "", description: "" },
  canale: [], // multiselect
  modDistribuzione: [], // multiselect
  mercato: [], // multiselect
  lineaBusiness: [], // multiselect
  tipologiaGaranzieMobilita: [], // multiselect
  tipologiaGaranziePersona: [], // multiselect
  tipologiaGaranzieCasaEFamiglia: [], // multiselect
  tipologiaGaranzieAzienda: [], // multiselect
  tipologiaGaranzieProfessionisti: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipoAssicurazione: { code: "", description: "" },
  combGaranzieTipologia: { code: "", description: "" },
  premioTipologia: [], // multiselect
  frazPremio: [], // multiselect
  rischiAssicuratiMobilita: [], // multiselect
  assistenzaBiciclettaMobilitaTipologia: [], // multiselect
  assistenzaInViaggioMobilitaTipologia: [], // multiselect
  rischiAssicuratiPersona: [], // multiselect
  assistenzaAllaPersonaTipologia: [], // multiselect
  tutelaLegalePersonaTipologia: [], // multiselect
  rischiAssicuratiCasaEFamiglia: [], // multiselect
  incendioAltriRischiCasaEFamigliaTipologia: [], // multiselect
  assistenzaCasaEFamigliaTipologia: [], // multiselect
  tutelaLegaleCasaEFamigliaTipologia: [], // multiselect
  rischiTecnologiciCasaEFamigliaTipologia: [], // multiselect
  animaliDomesticiCasaEFamigliaTipologia: [], // multiselect
  rischiAssicuratiAzienda: [], // multiselect
  incendioAltriRischiAziendaTipologia: [], // multiselect
  RCAltriRischiAziendaTipologia: [], // multiselect
  assistenzaAziendaTipologia: [], // multiselect
  tutelaLegaleAziendaTipologia: [], // multiselect
  rischiTecnologiciAziendaTipologia: [], // multiselect
  rischiAssicuratiProfessionisti: [], // multiselect
  RCProfAreaTecnicaAltriRischiTipologia: [], // multiselect
  RCProfAreaEconomicaGiuridicaAltriRischiTipologia: [], // multiselect
  RCProfAreaMedicaAltriRischiTipologia: [], // multiselect
};

export { selectChoices };
export default data;
